import React, { Suspense } from 'react';
import EditContainer from "./EditContainer";

const EditStore = (props) => {
    return (
        <EditContainer {...props} />
    );
};

export default EditStore;